// This file is generated by Style Dictionary
const tokens = {
  algae: '#4dac67',
  aliceBlue: '#f0f2f3',
  almondFrost: '#977a70',
  alpineRace: '#233d62',
  amaranth: '#d81b60',
  americanBlue: '#353670',
  amethyst: '#ab47bc',
  amethystDarkPurple: '#bc6cc9',
  antarticBlue: '#283e60',
  antiflashWhite: '#f2f4f7',
  'apricot-peach': '#fcc3bf',
  aquaDeep: '#004d40',
  articShadow: '#d7e9f4',
  articShadowPale: '#ebf4fa',
  auroraMagenta: '#943660',
  autumnHarvest: '#a56703',
  azalea: '#f3b6cc',
  azure: '#129ce7',
  bananaYellow: '#f2e93f',
  berwickBerry: '#6e86a6',
  bilobaFlower: '#9da9f3',
  bittersweet: '#ff706b',
  black: '#271a38',
  blackberryBlack: '#302548',
  bleachedCedar: '#251b36',
  blueChalk: '#ece9fb',
  blueEnchantment: '#0c6879',
  blueLagoon: '#00838f',
  blueLagoonDark: '#0096a3',
  blueLilac: '#edeff7',
  blueMarguerite: '#674eb1',
  blueRibbon: '#304ffe',
  blueSnuff: '#dbdeef',
  bridesmaid: '#fef0ef',
  brightCerulean: '#129ce7',
  brightGrey: '#e5e9ee',
  brinkPink: '#e96b7c',
  cabaretPink: '#d6497c',
  cantaloupe: '#f9ab2d',
  carouselPink: '#fcedf6',
  carrotOrange: '#f88e2c',
  catskillWhite: '#ebf5f6',
  cherub: '#f9dbe6',
  chinaGreenBlue: '#3e6467',
  chineseBellflower: '#4a56b3',
  chineseInk: '#3c312c',
  cinderella: '#fde1df',
  cloudBurst: '#1f2c4c',
  columbiaBlue: '#cbd3de',
  copper: '#c87132',
  cornflowerBlue: '#7f74ff',
  corsicanPurple: '#7a83ae',
  craterBrown: '#43282d',
  crimsonRed: '#950000',
  crocusPurple: '#8a76e8',
  crushedAlmond: '#d4c9c4',
  daisyBush: '#512da8',
  darkBlue: '#0026ca',
  darkJade: '#3b8880',
  darkJungleGreen: '#1b2b20',
  darkSpell: '#2f3d4a',
  deepBrick: '#f6dddd',
  deepLavender: '#5a5b80',
  desertStorm: '#f9f8f9',
  dimBrown: '#463542',
  dimgrey: '#6c6478',
  dodgerBlue: '#617bff',
  duskwood: '#163e53',
  dustyGold: '#f1e7d7',
  ebb: '#eae4e2',
  ebbPale: '#f4f1f0',
  ebonyClay: '#291f3d',
  elderberry: '#32234e',
  essexBlue: '#aed4ea',
  faintingLight: '#242946',
  fatBrown: '#332538',
  fiord: '#455a64',
  floralWhite: '#fffaee',
  fog: '#dee3ff',
  forgetMeNot: '#fff1ed',
  frenchLilac: '#e4c4ea',
  gainsboro: '#dad9dc',
  grandPlum: '#6c5658',
  grapefruit: '#ff5b55',
  greyMagenta: '#f2e2f4',
  greyMagentaPale: '#f8f0fa',
  greySelagoPale: '#f6eef7',
  guardsmanRed: '#d50000',
  gunPowder: '#45395c',
  haiti: '#20152d',
  herHighness: '#674eb1',
  herHighnessBlue: '#3e3370',
  imperialPurple: '#52315f',
  indianFig: '#56322f',
  indianPaleAle: '#cdc126',
  iron: '#c4cacd',
  janna: '#f4e3d6',
  kakitsubataBlue: '#4062b3',
  kokimurasakiPurple: '#3d1d3a',
  lightBlue: '#528eff',
  lightBlush: '#faeeee',
  lightPurple: '#d2b4eb',
  lilyWhite: '#ecf7fd',
  linen: '#fcebeb',
  linenPale: '#fdf5f5',
  lochmara: '#0277bd',
  logan: '#b4add4',
  lustyOrange: '#e26f2c',
  magnolia: '#f6f4fd',
  mangoTango: '#ea7000',
  mauveWhite: '#e1e5e6',
  melrose: '#bdc7ff',
  midGrey: '#605b68',
  minsk: '#413462',
  mirage: '#191024',
  moodyBlue: '#8676d4',
  moonGlow: '#fdfbe0',
  moonRaker: '#d6dcf7',
  moonRakerPale: '#ebeefb',
  morningAmber: '#e2ceae',
  murasakiPurple: '#844d91',
  naggarothNight: '#3d3856',
  navyBlue: '#140078',
  nebula: '#d6e3e0',
  newportIndigo: '#303c70',
  nightly: '#525d7a',
  opal: '#adc6c2',
  orange: '#ff5722',
  orientalSpice: '#8b5030',
  osloGrey: '#8d8994',
  paleLilac: '#dad3f8',
  palePurple: '#f4ecfa',
  paleSlate: '#c3bfc7',
  pastelBlue: '#9cc7f2',
  patriotBlue: '#393954',
  paua: '#2a254f',
  pauaBlue: '#28284f',
  pauaPurple: '#2f244f',
  perano: '#adbaee',
  persianBlue: '#1b349e',
  pigeonPost: '#b6bee0',
  pomegranate: '#d63d46',
  porcelaine: '#ebf1f0',
  powerOutage: '#392346',
  prelude: '#c7bce3',
  purpleOpulence: '#615398',
  reddestRed: '#9a4046',
  romanOrange: '#de5854',
  roseSharon: '#b94e00',
  roxyBrown: '#795548',
  royalPurple: '#7451eb',
  salmon: '#ff7b6d',
  saltpan: '#eef5ef',
  sapphireSparkle: '#0f5b88',
  seaGreen: '#2e7e32',
  seaShell: '#f2f1f3',
  selago: '#ecddee',
  shadowBlue: '#7a83ea',
  shakespearBlue: '#3a95cc',
  sinbad: '#add7db',
  sitterRed: '#3e2033',
  smaltBlue: '#4f9187',
  snuff: '#d9d6e9',
  snuffPale: '#ecebf4',
  softBlue: '#7586f0',
  softCoral: '#edbaba',
  spinelStoneBlack: '#28293b',
  sunsetMist: '#f8f3eb',
  swansdown: '#d6ebed',
  teenyBikini: '#316793',
  telopea: '#2c2740',
  telopeaGrey: '#2e2742',
  thistle: '#d9bbde',
  toledo: '#3b242e',
  tropicalBlue: '#aed4ea',
  tuna: '#362b4b',
  uclaBlue: '#5c7497',
  veryLightPurple: '#e9daf5',
  vibrantCrimson: '#c62828',
  vistorisLake: '#5a2646',
  vividPurple: '#7315c1',
  vividViolet: '#892b99',
  white: '#ffffff',
  whiteLilac: '#e3ddf1',
  whiteLilacPale: '#f1eef8',
  whiteLinen: '#f9f1eb',
  wineDregs: '#673241',
  woodyBrown: '#442437',
  yankeesBlue: '#1b2a40',
  yueMoonlight: '#5d52b3',
  zinfandel: '#5d2a39',
  zinnwaldite: '#e9c6ad',
  zircon: '#eef1ff',
};
export default tokens;
